export const authExpiredEvent = "holo-cargo-auth-expired";

export async function apiFetch(input: RequestInfo | URL, init?: RequestInit) {
  const response = await fetch(input, init);
  if (response.status === 401) {
    window.dispatchEvent(new Event(authExpiredEvent));
  }
  return response;
}

export async function readApiError(response: Response, fallback: string) {
  try {
    const body: unknown = await response.json();
    if (typeof body === "object" && body !== null && "message" in body) {
      return typeof body.message === "string" ? body.message : fallback;
    }
  } catch {
    // Keep the caller's useful fallback when an upstream response is not JSON.
  }
  return fallback;
}
